<template>
  <v-container id="page-center-detail">
    <div class="mb-5 page-title">{{$route.name}}</div>
    <v-tabs v-model="tab" slider-color="blue" slider-size="2">
      <v-tab v-for="menu in menuItems" @click="selectedMenu = menu">
        <span class="font-weight-bold"> {{ menu.title }} </span>
      </v-tab>
    </v-tabs>
    <v-tabs-items v-model="tab">
      <v-tab-item v-for="menu in menuItems">
        <component v-bind:is="menu.component"></component>
      </v-tab-item>
    </v-tabs-items>
  </v-container>
</template>

<script>
  import CenterInfo from './CenterInfo';
  import CenterFare from '@/views/Default/Center/CenterFare';
  import CenterUseList from "./CenterUseList";
  export default {
    components: {
      CenterInfo, CenterFare, CenterUseList
    },
    data() {
      return {
        tab:null,
        selectedMenu: {},
        menuItems: [
          {title : '센터 설정', component : 'CenterInfo'},
          {title : '요금제 설정', component : 'CenterFare'},
          {title : '용도 설정', component : 'CenterUseList'},
        ],
      }
    },
  }

</script>

<style scoped>

</style>
